/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import BaseResourceContainer from "../BaseResourceContainer";
import DataTable from "../DataTable";
import SchemaRegistry from "../../../services/SchemaRegistry";
import Navigation from "../../../Navigation";
import ParamParser from "../../../ParamParser";
import {deepEquals} from "../../../util";
import {
    GotoRecordAction, PageAction, PageActionActions, SetPageSizeAction,
    SetSortAction
} from "../../../services/PageAction";
import ActionButtons from "../ActionButtons";

class ResultList extends BaseResourceContainer {
    static propTypes = {
        params: PropTypes.shape({
            resource: PropTypes.string.isRequired,
            navResource: PropTypes.string.isRequired
        }).isRequired,
        location: PropTypes.object.isRequired,
        schema: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.onSort = this.onSort.bind(this);
        this.onChangePageSize = this.onChangePageSize.bind(this);
        this.onGotoRecord = this.onGotoRecord.bind(this);
        this.onAction = this.onAction.bind(this);
    }

    getResourceName(props, store) {
        let schema = this.getSchema(props);
        let schemaFieldName = (schema ? schema.getFieldName() : null);
        if (schemaFieldName) return schemaFieldName;
        super.getResourceName(props, store);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            nextProps.params.resource !== this.props.params.resource ||
            nextProps.schema !== this.props.schema ||
            nextState !== this.state ||
            !deepEquals(nextProps.location.query, this.props.location.query)
        );
    }

    /**
     *
     * @param props
     * @returns {Schema}
     */
    getSchema(props) {
        if (!props) props = this.props;
        return SchemaRegistry.getSchemaObjectForArray(props.params.resource, props.schema);
    }

    onSort(sort) {
        PageActionActions.callAction(new SetSortAction(null, sort));
    }

    onChangePageSize(size) {
        PageActionActions.callAction(new SetPageSizeAction(null, size));
    }

    onGotoRecord(recNo) {
        PageActionActions.callAction(new GotoRecordAction(null, recNo));
    }

    onAction(action, data) {
        let pageAction = new PageAction(action);
        pageAction.params = this.props.params;
        if (data) pageAction.data = data;
        PageActionActions.callAction(pageAction);
    }

    render() {
        if (!this.state.resource) return null;
        let schema = this.getSchema();
        let rowSchema = schema.field("*");
        let actions = this.getActions(schema.uiSchema);
        let tableActions = this.getActions(rowSchema.uiSchema);
        return (
            <div>
                <div className="row">
                    {this.renderActions(actions)}
                </div>
                <div className="row">
                    <DataTable
                        schema={schema}
                        data={this.state.resource.data}
                        actions={tableActions}
                        pageSize={this.state.resource.pageSize}
                        firstRecord={this.state.resource.firstRecord}
                        recordCount={this.state.resource.recordCount}
                        estimated={this.state.resource.estimated}
                        filter={this.state.resource.filter}
                        sort={this.state.resource.sort}
                        onSort={this.onSort}
                        onChangePageSize={this.onChangePageSize}
                        onGotoRecord={this.onGotoRecord}
                        onAction={this.onAction}
                        location={this.props.location}
                    />
                </div>
            </div>
        );
    }

    renderActions(actions) {
        if (!actions || actions.length == 0) return null;
        return (
            <div className="list-actions">
                <ActionButtons className="btn-group-xs" actions={actions} onAction={this.onAction} location={this.props.location}/>
            </div>
        );
    }

    getActions(uischema) {
        let actions = uischema.getAction();
        if (actions != null) {
            return _.map(actions, function (a) {
                return _.extend({}, a, {params: this.props.params});
            }.bind(this));
        }
        return null;
    }
}

export default ResultList;
